import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/EventPage.css";

/*
  Converted from the original PHP/HTML page.
  Image paths assume your images live in:
  E:\vanakkam\vanakkam\client\public\assets\images\...
  In React (CRA/Vite), anything inside /public is served from the root,
  so every image below is referenced as "/assets/images/xxx.png".
  If you use Vite and keep assets in src instead of public, swap these
  for imports.
*/

const IMG = "/assets";

/* =========================================================================
   TN HR ANNUAL SUMMIT 2026 — SECTIONS 1-9
   ========================================================================= */

const TNHR_IMG = {
  heroBg: `${IMG}/hero_event_1.jpg`,
  heroMap: `${IMG}/tnhr_tn_map.png`,
  heroLogo: `${IMG}/tnhr_hr_badge.png`,
  iconCalendar: `${IMG}/tnhr_icon_calendar.png`,
  iconLocation: `${IMG}/tnhr_icon_location.png`,

  statDay: `${IMG}/HRC-2026-icon3.png`,
  statSessions: `${IMG}/HRC-2026-icon4.png`,
  statExperts: `${IMG}/HRC-2026-icon5.png`,
  statPanel: `${IMG}/HRC-2026-icon6.png`,
  statAttendees: `${IMG}/HRC-2026-icon7.png`,
  statValue: `${IMG}/HRC-2026-icon8.png`,

  aboutImg1: `${IMG}/HRC-2026-image1.png`,
  aboutImg2: `${IMG}/HRC-2026-image2.png`,
  aboutImg3: `${IMG}/HRC-2026-image3.png`,
  aboutImg4: `${IMG}/HRC-2026-image4.png`,
  aboutImg5: `${IMG}/HRC-2026-image5.png`,
  aboutImg6: `${IMG}/HRC-2026-image6.png`,

  themeIcon1: `${IMG}/HRC-2026-icon9.png`,
  themeIcon2: `${IMG}/HRC-2026-icon10.png`,
  themeIcon3: `${IMG}/HRC-2026-icon11.png`,
 tick1: `${IMG}/HRC-2026-icon12.png`,
  tick2: `${IMG}/HRC-2026-icon13.png`,
  tick3: `${IMG}/HRC-2026-icon14.png`,

  whyIcon1: `${IMG}/HRC-2026-icon15.png`,
  whyIcon2: `${IMG}/HRC-2026-icon16.png`,
  whyIcon3: `${IMG}/HRC-2026-icon17.png`,
  whyIcon4: `${IMG}/HRC-2026-icon18.png`,
  whyIcon5: `${IMG}/HRC-2026-icon19.png`,
  whyIcon6: `${IMG}/HRC-2026-icon20.png`,
  whyIcon7: `${IMG}/HRC-2026-icon21.png`,
  whyIcon8: `${IMG}/HRC-2026-icon22.png`,
  whyIcon9: `${IMG}/HRC-2026-icon23.png`,
  whyIcon10: `${IMG}/HRC-2026-icon24.png`,

  whyBg: `${IMG}/HRC-2026-bgimage.jpg`,

  ticketIcon: `${IMG}/tnhr_icon_ticket.png`,
  attendIcon: `${IMG}/tnhr_icon_attend.png`,

  ctaPhone: `${IMG}/tnhr_icon_phone.png`,
  ctaMail: `${IMG}/tnhr_icon_mail.png`,
};


/* -------------------------------------------------------------------------
   Section 1 — Hero
   ------------------------------------------------------------------------- */

function TnhrHeroSection() {
  const [comingSoonMsg, setComingSoonMsg] = useState(false);

  const handleComingSoonClick = () => {
    setComingSoonMsg(true);

    setTimeout(() => {
      setComingSoonMsg(false);
    }, 2500);
  };

  return (
    <section id="hero" className="tnhr-hero">

      <div
        className="tnhr-hero-bg"
        style={{
          backgroundImage: `url(${TNHR_IMG.heroBg})`,
        }}
      ></div>

      <div className="tnhr-hero-shadow-layer"></div>

      <div className="tnhr-hero-content container">

        <div className="tnhr-hero-logo-row">
          <img
            src="/assets/AHR-2026-logo.png"
            alt="Tamil Nadu"
            className="tnhr-hero-map"
          />
        </div>

        <p className="tnhr-hero-subtitle">
          Uniting India’s HR Community,
          <span> One Powerful Summit.</span>
        </p>

        <p className="tnhr-hero-desc">
          Where people, culture, leadership, and workplace transformation
          come together.
        </p>

        <div className="tnhr-hero-pill-row">

          <span className="tnhr-hero-pill">
            <img src="/assets/HRC-2026-icon1.png" alt="" />
            19th December, 2026 (Saturday) |
          </span>

          <span className="tnhr-hero-pill">
            <img src="/assets/HRC-2026-icon2.png" alt="" />
            Chennai
          </span>

        </div>

        <button
          type="button"
          className="tnhr-hero-btn"
          onClick={handleComingSoonClick}
        >
          Coming soon
        </button>

        {/* {comingSoonMsg && (
          <div className="tnhr-hero-toast">
            Stay tuned — details coming soon!
          </div>
        )} */}

      </div>
    </section>
  );
}


/* -------------------------------------------------------------------------
   Section 2 — Stats strip
   ------------------------------------------------------------------------- */

const TNHR_STATS = [
  {
    id: 1,
    icon: TNHR_IMG.statDay,
    number: "01",
    label: "Day",
  },
  {
    id: 2,
    icon: TNHR_IMG.statSessions,
    number: "5+",
    label: "Sessions",
  },
  {
    id: 3,
    icon: TNHR_IMG.statExperts,
    number: "10+",
    label: "Industry Experts",
  },
  {
    id: 4,
    icon: TNHR_IMG.statPanel,
    number: "2+",
    label: "Panel Discussions",
  },
  {
    id: 5,
    icon: TNHR_IMG.statAttendees,
    number: "300+",
    label: "Attendees",
  },
  {
    id: 6,
    icon: null,
    number: TNHR_IMG.statValue,
    label: "Value",
  },
];

function TnhrStatsSection() {
  return (
    <section className="tnhr-stats">

      <div className="container">

        <h2 className="tnhr-heading">
          Tamil Nadu’s <span>Premier HR Summit 2026</span>
        </h2>

        <div className="tnhr-heading-line"></div>

        <div className="tnhr-stats-grid">

          {TNHR_STATS.map((s) => (

            <div
              className={`tnhr-stat-card${
                s.id === 6 ? " tnhr-stat-card-value" : ""
              }`}
              key={s.id}
            >

              {s.icon && (
                <div className="tnhr-stat-icon">
                  <img src={s.icon} alt="" />
                </div>
              )}

              <div className="tnhr-stat-number">
                {s.id === 6 ? (
                  <img src={s.number} alt="" />
                ) : (
                  s.number
                )}
              </div>

              <div className="tnhr-stat-label">
                {s.label}
              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}


/* -------------------------------------------------------------------------
   Section 3 — About TN HR Annual Summit 2026
   ------------------------------------------------------------------------- */

const TNHR_ABOUT_IMAGES = [
  TNHR_IMG.aboutImg1,
  TNHR_IMG.aboutImg2,
  TNHR_IMG.aboutImg3,
  TNHR_IMG.aboutImg4,
  TNHR_IMG.aboutImg5,
  TNHR_IMG.aboutImg6,
];

function TnhrAboutSection() {
  return (
    <section className="tnhr-about">

      <div className="container">

        {/* Left aligned About content */}
        <div className="tnhr-about-content">

          <h2 className="tnhr-heading">
            About <span>TN HR Annual Summit 2026</span>
          </h2>

          <div className="tnhr-heading-line"></div>

          <p className="tnhr-about-desc">
            TN Annual HR Summit 2026 brings together HR leaders, CHROs, business leaders, and people professionals to explore the evolving world of work.
          </p>
          <p className="tnhr-about-desc">
            From workplace culture and employee experience to AI, leadership, talent, and organizational transformation, the summit will spark conversations that matter.          </p>

          <div className="tnhr-about-highlight">
            Connect with 300+ industry professionals, exchange perspectives, discover new ideas, and gain insights to build stronger, people-first, future-ready workplaces.
          </div>

        </div>


        {/* About Gallery */}
        <div className="tnhr-about-gallery">

          {TNHR_ABOUT_IMAGES.map((img, i) => (

            <div
              className="tnhr-about-gallery-item"
              key={i}
            >

              <img
                src={img}
                alt={`TN HR Summit moment ${i + 1}`}
              />

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}


/* -------------------------------------------------------------------------
   Section 4 — Quote strip
   ------------------------------------------------------------------------- */

function TnhrQuoteSection() {
  return (
    <section className="tnhr-quote">

      <div className="container">

        <p className="tnhr-quote-text">

          <span className="tnhr-quote-mark">
            “
          </span>

          One Day. One Stage. The Future of HR in Tamil Nadu.

          <span className="tnhr-quote-mark">
            ”
          </span>

        </p>

      </div>

    </section>
  );
}


/* -------------------------------------------------------------------------
   Section 5 — Event Themes
   ------------------------------------------------------------------------- */

const TNHR_THEMES = [
  {
    id: 1,
    icon: TNHR_IMG.themeIcon1,
    tick: TNHR_IMG.tick1,
    title: "The New Era of Work: Culture, Capability & Change",
    points: [
      "Reimagining workplace culturee",
      "Building future-ready capabilities",
      "Leading change with confidence",
    ],
  },
  {
    id: 2,
    icon: TNHR_IMG.themeIcon2,
    tick: TNHR_IMG.tick2,
    title: "Human at the Heart of Transformation",
    points: [
      "Putting people at the center",
      "Empowering leaders and teams",
      "Creating meaningful employee experiences",
    ],
  },
  {
    id: 3,
    icon: TNHR_IMG.themeIcon3,
    tick: TNHR_IMG.tick3,
    title: "The Future of Work: People, Technology & Possibilities",
    points: [
      "Embracing AI and HR technology",
      "Connecting people with innovation",
      "Shaping future-ready workplacess",
    ],
  },
];

function TnhrThemesSection() {
  return (
    <section className="tnhr-themes">

      <div className="container">

        <h2 className="tnhr-heading">
          The Event Themes
        </h2>

        <div className="tnhr-heading-line"></div>

        <div className="tnhr-themes-grid">

          {TNHR_THEMES.map((t) => (

            <div
              className="tnhr-theme-card"
              key={t.id}
            >

              <div className={`tnhr-theme-icon theme-icon-${t.id}`}>
                <img src={t.icon} alt="" />
              </div>

              <h3 className="tnhr-theme-title">
                {t.title}
              </h3>

              <ul className="tnhr-theme-points">

                {t.points.map((p, i) => (

                  <li key={i}>

                    <img
                      src={t.tick}
                      alt=""
                    />

                    <span>
                      {p}
                    </span>

                  </li>

                ))}

              </ul>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}


/* -------------------------------------------------------------------------
   Section 6 — Why this TN HR Summit truly matters
   ------------------------------------------------------------------------- */

const TNHR_WHY_ITEMS = [
  {
    id: 1,
    icon: TNHR_IMG.whyIcon1,
    text: "Powerful HR Community",
  },
  {
    id: 2,
    icon: TNHR_IMG.whyIcon2,
    text: "Industry-Leading Speakers",
  },
  {
    id: 3,
    icon: TNHR_IMG.whyIcon3,
    text: "Meaningful Networking",
  },
  {
    id: 4,
    icon: TNHR_IMG.whyIcon4,
    text: "Future HR Trends",
  },
  {
    id: 5,
    icon: TNHR_IMG.whyIcon5,
    text: "Ideas That Create Impact",
  },
  {
    id: 6,
    icon: TNHR_IMG.whyIcon6,
    text: "Inspiration to Act",
  },
  {
    id: 7,
    icon: TNHR_IMG.whyIcon7,
    text: "Meet HR Leaders",
  },
  {
    id: 8,
    icon: TNHR_IMG.whyIcon8,
    text: "High-Energy Experience",
  },
  {
    id: 9,
    icon: TNHR_IMG.whyIcon9,
    text: "The Summit Effect",
  },
  {
    id: 10,
    icon: TNHR_IMG.whyIcon10,
    text: "Actionable Insights",
  },
];

function TnhrWhySection() {
  return (
    <section
      className="tnhr-why"
      style={{
        backgroundImage: `url(${TNHR_IMG.whyBg})`,
      }}
    >

      <div className="container tnhr-why-inner">

        <div className="tnhr-why-left">

          <h2 className="tnhr-why-heading">
            Why this TN HR Summit
            <span> truly matters</span>
          </h2>

        </div>

        <div className="tnhr-why-right">

          <div className="tnhr-why-grid">

            {TNHR_WHY_ITEMS.map((w) => (

              <div
                className="tnhr-why-card"
                key={w.id}
              >

                <span className="tnhr-why-icon">
                  <img src={w.icon} alt="" />
                </span>

                <span className="tnhr-why-text">
                  {w.text}
                </span>

              </div>

            ))}

          </div>

        </div>

      </div>

    </section>
  );
}


/* -------------------------------------------------------------------------
   Section 7 — Tickets
   ------------------------------------------------------------------------- */

const TNHR_TICKET_TICK_ICON = "/assets/HRC-2026-icon25.png";
const TNHR_TICKET_BTN_ICON = "/assets/HRC-2026-icon26.png";

const TNHR_TICKET_FEATURES = [
  "Full-Day Summit Experience",
  "Access to Keynotes & panel discussions",
  "Meaningful networking with hR Leaders",
  "Insights from industry experts",
  "lunch & Tea networking",
  "peer learning & knowledge exchange",
  "Exposure to emerging HR trends",
  "Opportunities to connect with selected speakers",
  "E-certificate of participation",
];

function TnhrTicketsSection() {

  const navigate = useNavigate();

  const handleBuyEarlyBird = () => {
    navigate("/eventform");
  };

  const handleBuyRegular = (e) => {
    e.preventDefault();
  };

  return (
    <section
      id="tnhr-tickets"
      className="tnhr-tickets"
    >

      <div className="container">

        <h2 className="tnhr-tickets-heading">
          Reserve Your Spot for
          <span> Tamil Nadu’s HR Gathering.</span>
        </h2>

        <p className="tnhr-tickets-subtitle">
          One Pass. One Powerful Day. Endless HR Connections.
        </p>

        <p className="tnhr-tickets-note">
          <strong>Note:</strong> Ticket pricing is subject to change without prior notice.
        </p>


        <div className="tnhr-tickets-grid">

          {/* Early Bird */}
          <div className="tnhr-ticket-card tnhr-ticket-early">

            <div className="tnhr-ticket-header">

              <span className="tnhr-ticket-label">
                Early Bird
              </span>

              <span className="tnhr-ticket-available">
                Available Till : 15th November, 2026
              </span>

              <span className="tnhr-ticket-price">
                ₹1999
              </span>

            </div>

            <ul className="tnhr-ticket-features">

              {TNHR_TICKET_FEATURES.map((f, i) => (

                <li key={i}>

                  <img
                    src={TNHR_TICKET_TICK_ICON}
                    alt=""
                  />

                  <span>
                    {f}
                  </span>

                </li>

              ))}

            </ul>

            <button
              type="button"
              className="tnhr-ticket-btn tnhr-ticket-btn-early"
              onClick={handleBuyEarlyBird}
            >

              <img
                src={TNHR_TICKET_BTN_ICON}
                alt=""
              />

              Buy Ticket

            </button>

          </div>


          {/* Regular */}
          <div className="tnhr-ticket-card tnhr-ticket-regular">

            <div className="tnhr-ticket-header">

              <span className="tnhr-ticket-label">
                Regular
              </span>

              <span className="tnhr-ticket-available">
                Available Till : 18th December, 2026
              </span>

              <span className="tnhr-ticket-price">
                ₹2299
              </span>

            </div>

            <ul className="tnhr-ticket-features">

              {TNHR_TICKET_FEATURES.map((f, i) => (

                <li key={i}>

                  <img
                    src={TNHR_TICKET_TICK_ICON}
                    alt=""
                  />

                  <span>
                    {f}
                  </span>

                </li>

              ))}

            </ul>

            <button
              type="button"
              className="tnhr-ticket-btn tnhr-ticket-btn-regular"
              onClick={handleBuyRegular}
            >

              <img
                src={TNHR_TICKET_BTN_ICON}
                alt=""
              />

              Buy Ticket

            </button>

          </div>

        </div>

      </div>

    </section>
  );
}

/* -------------------------------------------------------------------------
   Section 8 — Who Should Attend?
   ------------------------------------------------------------------------- */

const TNHR_ATTEND_ICON = "/assets/HRC-2026-icon27.png";

const TNHR_ATTENDEES = [
  "Founder, CEO & Chief Human Resource Officer",
  "HR Head, Director & Vice President",
  "HR Manager, Senior HR Professionalss",
  "Talent Acquisition & Campus Hiring Teams",
  "HR Recruiters, HRBP & HR Generalist",
];

function TnhrAttendSection() {
  return (
    <section className="tnhr-attend">

      <div className="container tnhr-attend-inner">

        <div className="tnhr-attend-left">

          <h2 className="tnhr-attend-heading">
            Who Should <span>Attend?</span>
          </h2>

          <p className="tnhr-attend-desc">
            Anyone shaping people, culture, and talent.
            <br />
            HR Summit welcomes leaders, practitioners, and change-makers from
            across the HR ecosystem.
          </p>

        </div>

        <div className="tnhr-attend-right">

          <ul className="tnhr-attend-list">

            {TNHR_ATTENDEES.map((a, i) => (

              <li key={i}>

                <span className="tnhr-attend-icon">
                  <img
                    src={TNHR_ATTEND_ICON}
                    alt=""
                  />
                </span>

                <span>
                  {a}
                </span>

              </li>

            ))}

          </ul>

        </div>

      </div>

    </section>
  );
}

/* -------------------------------------------------------------------------
   Section 9 — Final CTA
   ------------------------------------------------------------------------- */

const TNHR_FINAL_CTA_BTN_ICON = "/assets/HRC-2026-icon26.png";
const TNHR_FINAL_CTA_PHONE_ICON = "/assets/HRC-2026-icon28.png";
const TNHR_FINAL_CTA_MAIL_ICON = "/assets/HRC-2026-icon29.png";
const TNHR_FINAL_CTA_DECO = "/assets/HRC-2026-icon30.png";

function TnhrFinalCtaSection() {

  const handleJoinClick = () => {

    document
      .getElementById("tnhr-tickets")
      ?.scrollIntoView({
        behavior: "smooth",
      });

  };

  return (
    <section className="tnhr-final-cta">

      <img
        src={TNHR_FINAL_CTA_DECO}
        alt=""
        className="tnhr-final-cta-deco"
      />

      <div className="container">

        <h2 className="tnhr-final-cta-heading">

          Join the HR Leaders Shaping Tomorrow

          <br />

          Together,
          <span> We Build the Future of HR.</span>

        </h2>

        <p className="tnhr-final-cta-desc">

          Be part of a powerful community shaping the future of people,
          culture, and workplaces.

        </p>

        <button
          type="button"
          className="tnhr-final-cta-btn"
          onClick={handleJoinClick}
        >

          <img
            src={TNHR_FINAL_CTA_BTN_ICON}
            alt=""
          />

          Buy Ticket

        </button>


        <div className="tnhr-final-cta-contact">

          <span>

            <img
              src={TNHR_FINAL_CTA_PHONE_ICON}
              alt=""
            />

            +91 8248238229

          </span>

          <span>

            <img
              src={TNHR_FINAL_CTA_MAIL_ICON}
              alt=""
            />

            rajeshwaran@vanakkamhrd.com

          </span>

        </div>

      </div>

    </section>
  );
}

/* =========================================================================
   MAIN EVENT PAGE
   ========================================================================= */

export default function EventPage() {

  const navigate = useNavigate();

  /* ---------------- Countdown ---------------- */

  const [time, setTime] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const [circles, setCircles] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [eventStarted, setEventStarted] = useState(false);


  /* ---------------- Partners ---------------- */

  const partners = [
    {
      id: 1,
      name: "SILVER SPONSORS",

      logos: [
        {
          src: `${IMG}/Infoziant.png`,
          link: "https://infoziant.com",
        },
        {
          src: `${IMG}/good.png`,
          link: "https://www.goodfreshers.com/",
        },
        {
          src: `${IMG}/walk.png`,
          link: "https://www.walkzero.com/",
        },
        {
          src: `${IMG}/formula.png`,
          link: "https://formulahr.com/",
        },
        {
          src: `${IMG}/hire.png`,
          link: "https://www.hireglint.ai/",
          big: true,
        },
      ],
    },

    {
      id: 7,
      name: "ASSOCIATION PARTNER",

      logos: [
        {
          src: `${IMG}/test_your.jpeg`,
          link: "https://example.com/newpartner",
        },
      ],
    },

    {
      id: 2,
      name: "EXCLUSIVE PARTNER",

      logos: [
        {
          src: `${IMG}/out.png`,
          link: "",
        },
      ],
    },

    {
      id: 3,
      name: "VENUE PARTNER",

      logos: [
        {
          src: `${IMG}/venue.jpeg`,
          link: "",
        },
      ],
    },

    {
      id: 4,
      name: "KNOWLEDGE PARTNER",

      logos: [
        {
          src: `${IMG}/dina_4.png`,
          link: "",
        },
      ],
    },

    {
      id: 5,
      name: "MENTAL WELLNESS PARTNER",

      logos: [
        {
          src: `${IMG}/dina_5.png`,
          link: "",
        },
      ],
    },

    {
      id: 6,
      name: "MEDIA PARTNER",

      logos: [
        {
          src: `${IMG}/dina_3.png`,
          link: "",
        },
      ],
    },
  ];


  /* ---------------- Previous Events ---------------- */

  const previousEvents = [

    {
      id: 1,
      image: `${IMG}/PE_HRC_26.png`,
      title: "India HR Confluence 2026",
      date: "August 29, 2026 - 9:30 AM",
      location:
        "Dr.N.G.P. Arts and Science College, Coimbatore",
    },

    {
      id: 2,
      image: `${IMG}/PE_LHRF_26.png`,
      title: "India’s Largest HR Festival 2026",
      date: "July 11, 2026 - 9:30 AM",
      location:
        "Chennai Trade Centre, Chennai",
    },

    {
      id: 3,
      image: `${IMG}/PE_HRC_25.png`,
      title: "HR Confluence 2025",
      date: "August 23, 2025 - 9:30 AM",
      location:
        "Chennai Trade Centre, Chennai",
    },

    {
      id: 4,
      image: `${IMG}/PE_HF_25.png`,
      title: "HR Festival 2025",
      date: "July 05, 2025 - 9:30 AM",
      location:
        "Chennai Trade Centre, Chennai",
    },

  ];


  return (
    <>

      {/* ===================== Section 1 — Hero ===================== */}

      <TnhrHeroSection />


      {/* ===================== Section 2 — Stats ===================== */}

      <TnhrStatsSection />


      {/* ===================== Section 3 — About ===================== */}

      <TnhrAboutSection />


      {/* ===================== Section 4 — Quote strip ===================== */}

      <TnhrQuoteSection />


      {/* ===================== Section 5 — Event Themes ===================== */}

      <TnhrThemesSection />


      {/* ===================== Section 6 — Why this summit matters ===================== */}

      <TnhrWhySection />


      {/* ===================== Section 7 — Tickets ===================== */}

      <TnhrTicketsSection />


      {/* ===================== Section 8 — Who Should Attend ===================== */}

      <TnhrAttendSection />


      {/* ===================== Section 9 — Final CTA ===================== */}

      <TnhrFinalCtaSection />


      {/* ===================== Section 10 — Previous Events ===================== */}

      <section className="prev-events-section">

        <div className="container">

          <h2 className="prev-events-heading">
            Previous Events
          </h2>

          <div className="prev-events-heading-line"></div>


          <div className="prev-events-grid">

            {previousEvents.map((ev) => (

              <div
                className="prev-event-card"
                key={ev.id}
              >

                <div className="prev-event-image">

                  <img
                    src={ev.image}
                    alt={ev.title}
                    onError={(e) => {

                      console.error(
                        "Image failed to load:",
                        ev.image
                      );

                      e.currentTarget.onerror = null;

                      e.currentTarget.style.display =
                        "none";

                      e.currentTarget.parentElement.classList.add(
                        "prev-event-image-broken"
                      );

                    }}
                  />

                </div>


                <div className="prev-event-info">

                  <h3 className="prev-event-title">
                    {ev.title}
                  </h3>


                  <div className="prev-event-meta">

                    <img
                      src={`${IMG}/PE_icon_01.png`}
                      alt=""
                      className="prev-event-icon"
                    />

                    <span>
                      {ev.date}
                    </span>

                  </div>


                  <div className="prev-event-meta">

                    <img
                      src={`${IMG}/PE_icon_02.png`}
                      alt=""
                      className="prev-event-icon"
                    />

                    <span>
                      {ev.location}
                    </span>

                  </div>


                  <button
                    className="prev-event-btn"
                    onClick={() => {

                      if (ev.id === 1) {

                        navigate("/hrc2026");

                      } else {

                        document
                          .getElementById("hero")
                          ?.scrollIntoView({
                            behavior: "smooth",
                          });

                      }

                    }}
                  >
                    Know more
                  </button>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

    </>
  );
}


/* =========================================================================
   Small reusable pieces
   ========================================================================= */

function CountdownItem({
  label,
  value,
  offset,
  circleId,
}) {

  return (

    <div className="countdown-item">

      <div className="circle">

        <svg>

          <circle
            className="circle-bg"
            cx="65"
            cy="65"
            r="40"
          ></circle>

          <circle
            className="circle-progress"
            cx="65"
            cy="65"
            r="40"
            id={circleId}
            style={{
              strokeDasharray:
                2 * Math.PI * 40,
              strokeDashoffset: offset,
            }}
          ></circle>

        </svg>

        <div className="countdown-number">
          {value}
        </div>

      </div>

      <div className="countdown-label">
        {label}
      </div>

    </div>
  );
}


function StatCard({
  iconClass,
  icon,
  number,
  label,
}) {

  return (

    <div className="stat-card">

      <div className="stat-top">

        <div className={iconClass}>

          <img
            src={`${IMG}/${icon}`}
            alt="Day"
          />

        </div>

        <div className="stat-number">
          {number}
        </div>

      </div>

      <div className="stat-text">

        <strong>
          {label}
        </strong>

      </div>

    </div>
  );
}


function HighlightCard({
  img,
  title,
}) {

  return (

    <div className="highlight-card">

      <div className="highlight-image">

        <img
          src={`${IMG}/${img}`}
          alt={title}
        />

      </div>

      <div className="highlight-title">
        {title}
      </div>

    </div>
  );
}


function WhyPill({
  icon,
  text,
}) {

  return (

    <div className="why-pill">

      <span className="why-icon">

        <img
          src={`${IMG}/${icon}`}
          alt=""
        />

      </span>

      <span className="why-text">
        {text}
      </span>

    </div>
  );
}


function SpeakerCard({
  linkedin,
  photo,
  name,
  role,
  company,
}) {

  return (

    <div className="spk-card">

      <a
        href={linkedin}
        className="spk-linkedin"
        target="_blank"
        rel="noreferrer"
        aria-label={`${name} LinkedIn Profile`}
      >

        <img
          src={`${IMG}/speker_lin.png`}
          alt="LinkedIn"
        />

      </a>


      <div className="spk-photo">

        <img
          src={`${IMG}/${photo}`}
          alt="Speaker Name"
        />

      </div>


      <div className="spk-info">

        <h3 className="spk-name">
          {name}
        </h3>

        <p className="spk-role">
          {role}
        </p>

        <p className="spk-company">
          {company}
        </p>

      </div>

    </div>
  );
}